import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chip = _resolveComponent("chip")!
  const _component_chip_list = _resolveComponent("chip-list")!

  return (_openBlock(), _createBlock(_component_chip_list, {
    "data-items": _ctx.allFilterChips,
    selection: "none",
    chip: "myTemplate"
  }, {
    myTemplate: _withCtx(({props}) => [
      _createVNode(_component_chip, {
        rounded: "full",
        text: props.dataItem.text,
        value: props.dataItem.value,
        removable: props.dataItem.removable,
        onClick: props.dataItem.onClick,
        onRemove: ($event: any) => (_ctx.onRemove(props.dataItem)),
        "theme-color": null,
        class: _normalizeClass([
                        _ctx.getClassName(props.dataItem),
                        props.dataItem.onClick == null ? 'filter-non-clickable' : null
                     ])
      }, null, 8, ["text", "value", "removable", "onClick", "onRemove", "class"])
    ]),
    _: 1
  }, 8, ["data-items"]))
}